(function () {
  if (window.__lcSleevePrintsBound) return;
  window.__lcSleevePrintsBound = true;

  function printInputFromEvent(event) {
    var node = event.target;
    if (!node) return null;
    if (node.tagName === 'LABEL') {
      var forId = node.getAttribute('for');
      node = forId ? document.getElementById(forId) : node.querySelector('input[type="radio"]');
    } else if (node.closest) {
      var label = node.closest('label');
      if (label && label.htmlFor) node = document.getElementById(label.htmlFor) || node;
    }
    if (!node || node.tagName !== 'INPUT' || node.type !== 'radio') return null;
    if (!node.closest('.lc-sleeve-prints')) return null;
    return node;
  }

  function selectFallbackSize(input) {
    if (!input || input.getAttribute('data-lc-print-available') !== 'false') return;
    var fallbackId = input.getAttribute('data-lc-fallback-size-id');
    if (!fallbackId) return;
    var root = input.closest('variant-selects');
    if (!root) return;
    var sizeInput = root.querySelector('input[data-option-value-id="' + fallbackId + '"]');
    if (sizeInput && !sizeInput.checked) sizeInput.checked = true;
  }

  document.addEventListener(
    'click',
    function (event) {
      selectFallbackSize(printInputFromEvent(event));
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      selectFallbackSize(printInputFromEvent(event));
    },
    true
  );
})();
